// src/components/forms/hooks/useBookingFormModals.ts

import { useState, useCallback } from 'react';

export type ModalType =
  | 'pet-stay'
  | 'pet-grooming'
  | 'kennel-heater'
  | 'surcharge'
  | 'global-rate'
  | 'global-heater'
  | 'price-list'
  | null;

/**
 * Consolidated modal state management for BookingForm
 * Replaces 8 separate state variables with single unified controller
 */
export const useBookingFormModals = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [editingItemId, setEditingItemId] = useState<number | null>(null);

  const openModal = useCallback((modalType: ModalType, itemId?: number) => {
    setActiveModal(modalType);
    setEditingItemId(itemId ?? null);
  }, []);

  const closeModal = useCallback(() => {
    setActiveModal(null);
    setEditingItemId(null);
  }, []);

  const isOpen = useCallback(
    (modalType: ModalType) => activeModal === modalType,
    [activeModal]
  );

  return {
    activeModal,
    editingItemId,
    openModal,
    closeModal,
    isOpen,
  };
};
